<div class="tracking-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Live Location Board</p>
      <h2>Tracking</h2>
      <p class="subtitle">Track rider and vehicle positions from the latest GPS pings, with a manual ping form for testing and fallback operations.</p>
    </div>
    <button mat-stroked-button (click)="loadPage()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="hero-strip" *ngIf="dashboard">
    <article class="hero-tile">
      <span>Live Units</span>
      <strong>{{ dashboard.liveUnits }}</strong>
      <small>Fresh location updates in the last 5 minutes</small>
    </article>
    <article class="hero-tile">
      <span>Stale Units</span>
      <strong>{{ dashboard.staleUnits }}</strong>
      <small>Updates older than 5 minutes but newer than 30 minutes</small>
    </article>
    <article class="hero-tile critical">
      <span>Offline Units</span>
      <strong>{{ dashboard.offlineUnits }}</strong>
      <small>No recent GPS update captured</small>
    </article>
    <article class="hero-tile accent">
      <span>Active Trips</span>
      <strong>{{ dashboard.activeTrips }}</strong>
      <small>Units currently linked to a tracking ID</small>
    </article>
  </section>

  <section class="tracking-grid">
    <article class="panel map-panel">
      <div class="panel-head">
        <h3>Operations Board</h3>
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="selectedStatus">
            <mat-option value="all">All</mat-option>
            <mat-option value="live">Live</mat-option>
            <mat-option value="stale">Stale</mat-option>
            <mat-option value="offline">Offline</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="board-surface" *ngIf="boardUnits.length; else emptyBoard">
        <div class="board-grid-lines"></div>
        <button
          type="button"
          class="unit-pin"
          *ngFor="let unit of boardUnits"
          [class.live]="unit.status === 'Live'"
          [class.stale]="unit.status === 'Stale'"
          [class.offline]="unit.status === 'Offline'"
          [style.left.%]="unit.positionX"
          [style.top.%]="unit.positionY"
        >
          <span>{{ unit.vehiclePlateNumber || unit.riderName }}</span>
        </button>
      </div>
    </article>

    <article class="panel">
      <div class="panel-head">
        <h3>Record Ping</h3>
        <span>Manual test/update</span>
      </div>

      <div class="ping-form">
        <mat-form-field appearance="outline">
          <mat-label>Rider</mat-label>
          <mat-select [(ngModel)]="ping.riderId">
            <mat-option *ngFor="let rider of riders" [value]="rider.id">{{ rider.fullName }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Tracking ID</mat-label>
          <input matInput [(ngModel)]="ping.trackingId" placeholder="REQ-12345678">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Latitude</mat-label>
          <input matInput type="number" [(ngModel)]="ping.latitude">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Longitude</mat-label>
          <input matInput type="number" [(ngModel)]="ping.longitude">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Accuracy (m)</mat-label>
          <input matInput type="number" [(ngModel)]="ping.accuracyMeters">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Battery (%)</mat-label>
          <input matInput type="number" [(ngModel)]="ping.batteryLevel">
        </mat-form-field>
      </div>

      <div class="panel-actions">
        <button mat-flat-button color="primary" (click)="savePing()">Save Ping</button>
      </div>
    </article>

    <article class="panel wide">
      <div class="panel-head">
        <h3>Tracked Units</h3>
        <span>{{ visibleUnits.length }} visible</span>
      </div>

      <div class="unit-list" *ngIf="visibleUnits.length; else noUnits">
        <div class="unit-card" *ngFor="let unit of visibleUnits" [class.live]="unit.status === 'Live'" [class.stale]="unit.status === 'Stale'" [class.offline]="unit.status === 'Offline'">
          <div>
            <strong>{{ unit.riderName }}</strong>
            <p>{{ unit.vehiclePlateNumber || 'No vehicle assigned' }}</p>
          </div>
          <div class="unit-meta">
            <span class="badge" [ngClass]="statusTone(unit)">{{ unit.status }}</span>
            <small>{{ unit.recordedAt ? (unit.recordedAt | date:'medium') : 'No ping yet' }}</small>
          </div>
          <div class="unit-facts">
            <span>Trip: {{ unit.trackingId || 'None' }}</span>
            <span>Coords: {{ unit.latitude || 0 }}, {{ unit.longitude || 0 }}</span>
            <span>Accuracy: {{ unit.accuracyMeters || 0 }}m</span>
            <span>Battery: {{ unit.batteryLevel || 0 }}%</span>
            <span>Phone: {{ unit.assignedPhoneNumber || unit.riderPhoneNumber || '-' }}</span>
          </div>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #emptyBoard>
  <p class="muted">No live positions yet. Save a ping to place a rider on the board.</p>
</ng-template>

<ng-template #noUnits>
  <p class="muted">No tracked units match the selected status.</p>
</ng-template>
